import { useState,useEffect, useRef } from "react";
import "./css/App.css"

import {client_url,server_URL,upload_URL,setSS,getSS,isMobile,sortingTypes,sortingTypes2 } from ".";

import { FileUploader } from "react-drag-drop-files";

function App() {
  const userinput_ref = useRef(null)

  const [files, setFile] = useState([]);

  const fetchedfiledata = useRef([])
  const soretedDictData = useRef({})
  const [visibleFileData,setVisibleFiledata] = useState([])
  const userSelectedItems = useRef({})



  const [filedisplayarr, setfiledisplayarr] = useState([]); // for downloading (might remove soon)
  const [dragdrop,setdragdrop] = useState(false)
  const [progress,setprogress] = useState(null)

  const [fatalerrormessage,setfatalerrormessage] = useState(null)
  const [globalmessage,setglobalmessage] = useState(null)
  const [navbartooltip,settooltip] = useState(null)

  const [availablestoragedisplay,setavailablestoragedisplay] = useState(null)

  const itemperpage = useRef(0);
  const curPage = useRef(1)
  const [currentfolderpath,setcurrentfolderpath] = useState("")
  const [pagenav,setpagenav] = useState(null)

  const [misc_components,setMISCDIV] = useState(null)
  const [togglecancelbutton,settogglecancelbutton] = useState(false)
  const [cancelbutton,setcancelbutton] = useState(null)

  const [pagechangediv, setpagechangediv] = useState(null)
  const [pagechangestate, setpagechangestate] = useState(false)
  const [flashfolderpagediv,setflashfolderpagediv] = useState(null)

  const [togglepanels,settogglepanels] = useState(1)
  const maxPanels = 2
  const [hidesystemtray, sethidesystemtray] = useState(true)

  const [sorting,setsorting] = useState(1)
  const [sorting2,setsorting2] = useState(1) // ascending,descending
  const [sortingdisplaydiv,setsortingdisplaydiv] = useState(null)
  
  const oldswipingY = useRef(null) // only for mobile
  const swipingY = useRef(null); // only for mobile
  const oldswipingX = useRef(null) // only for mobile
  const Ythreshold = 50 // only for mobile
  const swipingX = useRef(null);

  const swipingThresholdPC = 100 // 50pixels for PC
  const extraswipingThresholdPC = 400 //400pixels for PC
  const swipingThresholdMB = 50 // for Mobile
  const extraswipingThresholdMB = 150 // for Mobile

  const maxconcurrentdownloads = 3

  const itemsperrow = useRef(null)
  const thumbnailwidth = useRef(null)

  const contentDiv = useRef(null)
  const ScrollParentDiv = useRef(null)

  const beginUserDragging = useRef(false)
  const startingDraggedPosition = useRef(null)
  const [draggedDisplayDiv,setDraggedDisplayDiv] = useState(null)
  const [draggedDisplayValues,setDraggedDisplayValues] = useState(null)


  async function server_handshake(){
    try {
      const output = await fetch(server_URL()+"serverhandshake/"+new URLSearchParams(window.location.search).get("cached"),{
        method:"GET",
        headers:{
          "Content-Type":"application/json"
        }
      })
      .then(response=>response.json())
      .then(data=>data)
      return output
    } catch (error) {
      return {"state":"invalid","message":"error connecting to server"}
    }
  }
  function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  async function fileDetectedfunction(files){
    const handshake = await server_handshake()
    if (handshake["state"]=="invalid"){
      setfatalerrormessage(handshake["message"])
      return
    }

    var totalsize = 0
    Array.from(files).map((file)=>{
      totalsize+=file.size
    })
    const output = await fetch(server_URL()+"checkuseruploadlimit/"+new URLSearchParams(window.location.search).get("cached"),{
      method:"GET",
      headers:{
        "Content-Type":"application/json"
      }
    })
    .then(response=>response.json())
    .then(data=>data)
    
    settogglecancelbutton(false)
    setMISCDIV(null)

    var limit = parseFloat(output["message"])
    if (limit<totalsize){
        displayglobalmessage("total size of files exceeded "+limit/1000/1000+"MB")
        return
    }

    setFile(Array.from(files))
  }
  let invalidDownloads = []
  const threads = {};
  useEffect(()=>{
    const FDA = []
    for(let i=files.length-1;i>=0;i--){
      FDA.push(
        <div className="filedisplaycomponentcss" style={{textAlign:"center"}} type={files[i]["type"]} id={i}>
          {files[i]["name"]}
        </div>
      )
    }
    setfiledisplayarr(FDA)
    if(files.length===0){
      return
    }
    invalidDownloads = []

    sendFilesToServer()
  },[files])




  function startThread(name, fn, interval = 2000) {
    if (threads[name]) return;

    let stopped = false;

    async function loop() {
      if (stopped) return;
      await fn();
      setTimeout(loop, interval);
    }

    threads[name] = () => (stopped = true);
    loop();
  } 
  async function sendFilesToServer(){
    if(files.length===0){
      if(invalidDownloads.length==0){
        return
      }
      const invaliduploadarr = []
      for (const arr of invalidDownloads){
        invaliduploadarr.push(
          <div style={{display:'flex',width:"90%",height:"fitContent",flexDirection:"column",margin:"3px",borderBottom:"1px solid black"}}>
            <span>name: {arr[0]}</span>
            <span>reas: {arr[1]}</span>
          </div>
        )
      }
      invalidDownloads = []
      setMISCDIV(
        <div style={{position:"absolute",left:"0px",top:"0px",right:"0px",bottom:"0px",zIndex:"1010",background:"rgba(0.5,0.5,0.5,0.2)"}}>
          <div style={{display:"flex",flexDirection:"column",padding:"10px",border:"2px solid black",background:"white",height:"fit-content",width:"fit-content",position:"relative",left:"50%",top:"50%",transform:"translate(-50%,-50%)",borderRadius:"15px"}}>
            <div style={{width:"100%",display:"flex",alignContent:"center",justifyContent:"center",fontWeight:"bold",fontSize:"20px",cursor:"default"}}>Files not uploaded</div>
            <div style={{width:"100%",height:"300px",overflowY:"auto",overflowX:"hidden",display:'flex',flexDirection:"column",alignItems:"center",border:"1px solid black",marginTop:"5px"}}>
              {invaliduploadarr}
            </div>
          </div>
        </div>
      )
      settogglecancelbutton(true)
      return
    }

    const currentCache = new URLSearchParams(window.location.search).get("cached")
    const currentFolder = new URLSearchParams(window.location.search).get("folder")
    
    setprogress(null)

    const file = files.pop(0)
    const output = await fetch(server_URL()+"convert_video_stats_to_required",{
      method: 'POST',
      headers: {
        "Content-Type":"application/json"
      },
      body: JSON.stringify({
        "user_cache":currentCache,
        "video_bytes":file.size,
        "file_name":file.name,
        "folderID":currentFolder,
        "file_type":file.type
      }),
    })
    .then(response =>response.json())
    .then(data=>data)


    if(output["status"]==false){ // error while uploading and stuff
        invalidDownloads.push([file.name,output["message"]])
        setfiledisplayarr(prevItems => prevItems.filter((_, index) => index !== 0));
        await sleep(500);
        sendFilesToServer()
        return
    }

    startThread(output["ID"], async () => {
      const progress = await fetch(server_URL()+"fetch_upload_percentage/"+output["ID"]).then(response=>response.json()).then(data=>data)
      const prog = progress["message"]+"%"
      setprogress(<div style={{height:"100%",width:prog,background:"green"}}></div>)
      if (progress["message"]>="100"){
        setprogress(null)
        setfiledisplayarr(prevItems => prevItems.filter((_, index) => index !== 0));
        threads[output["ID"]]();
        delete threads[output["ID"]]; // erase thread
        await sleep(300);
        sendFilesToServer()
      }
    });

    
    const totalSize = file.size
    const total_chunks = output["chunks"]
    const sizeperchunk = Math.ceil(totalSize/total_chunks)
    const fileChunks = []
    var offset = 0
    while(offset<totalSize){
      const chunk = file.slice(offset, offset + sizeperchunk);
      offset = sizeperchunk+ offset
      fileChunks.push(chunk)
    }

    let index = 0
    async function worker() {
      while (index < fileChunks.length) {
        const chunk = fileChunks[index];

        const formData = new FormData();
        formData.append("videoID", output["ID"]);
        formData.append("user_cache", currentCache);
        formData.append("chunk_index", index);
        formData.append("file", chunk);

        await fetch(upload_URL(), {
          method: "POST",
          body: formData,
        });
        index+=1
      }
    }
    const workers = Array.from({ length: maxconcurrentdownloads }, worker);
    await Promise.all(workers);

    // for (let index = 0;index<fileChunks.length;index++){
    //   const formData = new FormData();
    //   formData.append("videoID",output["ID"])
    //   formData.append("user_cache",currentCache)
    //   formData.append("chunk_index",index)
    //   formData.append("file",fileChunks[index])
    //   await fetch(upload_URL(),{
    //     method: 'POST',
    //     body: formData,
    //   })
    // }

  }

  
  const handledragleave = (e) =>{
    e.preventDefault();
    setdragdrop(false);
  }
  const handledragover = (e) =>{
    e.preventDefault();
    if(fatalerrormessage!=null){
      return
    }
    setdragdrop(true)
  }
  const handleDrop = (e) =>{
    e.preventDefault()
    if(fatalerrormessage!=null){
      return
    }
    setdragdrop(false)
    fileDetectedfunction(e.dataTransfer.files)
  }

  const handlePointerDown = (e) =>{
    if(e.clientX == null){
      swipingX.current = e.touches[0].clientX
      oldswipingX.current = swipingX.current
      swipingY.current = e.touches[0].clientY
      oldswipingY.current = swipingY.current
    }
    else{
      swipingX.current = e.clientX
    }
  }
  const handlePointerUp = (e) =>{
    let diff = 0
    if(e.clientX == null){
      diff = oldswipingX.current-swipingX.current
      const YDIFF = oldswipingY.current-swipingY.current //MOBILE ONLY
      if((YDIFF>0?YDIFF:YDIFF*-1)>Ythreshold){
        return
      }
    }
    else{
      diff = swipingX.current-e.clientX
    }
    oldswipingX.current = 0
    swipingX.current = 0
    if((diff>0?diff:diff*-1)<=(isMobile()?swipingThresholdMB:swipingThresholdPC)){
      return
    }
    let value = ""
    if(diff<0){
      if(diff*-1>(isMobile()?extraswipingThresholdMB:extraswipingThresholdPC)){
        value = "backfull"
      }
      else{
        value = "back1"
      }
    }
    if(diff>0){
      if(diff>(isMobile()?extraswipingThresholdMB:extraswipingThresholdPC)){
        value = "nextfull"
      }
      else{
        value = "next1"
      }
    }

    if(value==""){
      return
    }
    const div = document.getElementById(value)
    if(div.classList.contains("pagenavcompdisabledcss")){
      return
    }
    ScrollParentDiv.current.scrollTop = 0
    fetchfoldercontent(new URLSearchParams(window.location.search).get("folder"),parseInt(div.getAttribute("value")))
  }
  const handleTouchMove = (e) => {
    swipingX.current = e.touches[0].clientX
    swipingY.current = e.touches[0].clientY
  }

  const handlemouseclicked = (e) => {
    beginUserDragging.current = true
    startingDraggedPosition.current = [e.clientX,e.clientY]
  }
  const handlemousereleased = (e) => {
    beginUserDragging.current = false
    if(draggedDisplayValues==null) return
    if (draggedDisplayValues[2]<50&&draggedDisplayValues[3]<100) return
    for (const filedata of visibleFileData){
      const temp = filedata.props.style
      if(temp.width ==null || temp.height == null) continue
      if(temp.left+parseFloat(temp.width.replace("px",""))<draggedDisplayValues[0]+25){
        continue
      }
      if(temp.top+parseFloat(temp.height.replace("px",""))<draggedDisplayValues[1]+20){
        continue
      }
      if(temp.left>draggedDisplayValues[0]+draggedDisplayValues[2]-100){
        continue
      }
      if(temp.top>draggedDisplayValues[1]+draggedDisplayValues[3]-100){
        continue
      }

      const temp2 = filedata.props
      const divJson = {
        "id":temp2.id,
        "type":temp2.type,
        "file_index":temp2.file_index
      }
    
      if (!(divJson["id"] in userSelectedItems.current)){
        userSelectedItems.current[divJson["id"]] = divJson
      }
      
      document.getElementById(divJson["id"]).style.background = "rgba(118, 252, 252, 0.25)"
    }
    // setVisibleFiledata(prev =>
    //     prev.map((item) => {
    //       const temp = item.props.style
    //       if(temp.width ==null || temp.height == null) return item
    //       if(temp.left+parseFloat(temp.width.replace("px",""))<DR[0]){
    //         return item
    //       }
    //       if(temp.top+parseFloat(temp.height.replace("px",""))<DR[1]){
    //         return item
    //       }
    //       if(temp.left>DR[0]+DR[2]){
    //         return item
    //       }
    //       if(temp.top>DR[1]+DR[3]){
    //         return item
    //       }

    //       const temp2 = item.props
    //       const divJson = {
    //         "id":temp2.id,
    //         "type":temp2.type,
    //         "file_index":temp2.file_index
    //       }
        
    //       if (!(divJson["id"] in userSelectedItems.current)){
    //         userSelectedItems.current[divJson["id"]] = divJson
    //       }
          
    //       return cloneElement(item, {
    //         style: {
    //           ...temp,
    //           background: "rgba(118, 252, 252, 0.25)"
    //         }
    //       });
    //     })
    // )
      
    setDraggedDisplayDiv(null)
    setDraggedDisplayValues(null)
  }
  const handlemousemoved = (e) => {
    if(!beginUserDragging.current) return
    const currentScrolled = ScrollParentDiv.current.scrollTop
    const newMouse = [e.clientX,e.clientY]
    const oldMouse = startingDraggedPosition.current
    
    let leftvalue = oldMouse[0]
    let topvalue = oldMouse[1]
    let widthvalue = newMouse[0]-oldMouse[0]
    let heightvalue = newMouse[1]-oldMouse[1]
    if (newMouse[0] - oldMouse[0] < 0){
      leftvalue = newMouse[0]
      widthvalue = oldMouse[0] - newMouse[0]
    }
    if (newMouse[1] - oldMouse[1] < 0){
      topvalue = newMouse[1]
      heightvalue = oldMouse[1] - newMouse[1]
    }

    setDraggedDisplayDiv(
      <div style={{position:"absolute",left:leftvalue,top:topvalue,width:widthvalue,height:heightvalue,pointerEvents:"none",background:"rgba(196, 229, 240, 0.42)",borderRadius:"5px"}}></div>
    )
    setDraggedDisplayValues([leftvalue,topvalue+currentScrolled,widthvalue,heightvalue])
  }

  const allmodules = ["createfolder","removecontent","movecontent","findfolders"]
  async function enter_function(key,module_index) {
    if(key!="Enter"){
      if(key=="Escape"){
        cancelmodule()
      }
      return
    }

    if(allmodules[module_index]=="createfolder"){
      createfoldermodule()
      return
    }
    if(allmodules[module_index]=="removecontent"){
      removecontentmodule()
      return
    }
    if(allmodules[module_index]=="movecontent"){
      movecontentsmodule()
      return
    }
    if(allmodules[module_index]=="findfolders"){
      findfoldersmodule()
      return
    }
  }
  async function createfoldermodule() {
    const handshake = await server_handshake()
    if (handshake["state"]=="invalid"){
      setfatalerrormessage(handshake["message"])
      return
    }
    
    const input = userinput_ref.current.value
    if(input==""||input==null){
      displayglobalmessage("Folder name cant be empty")
      return
    }
    const response = await fetch(server_URL()+"createfolder",{
      method:"POST",
      headers:{
        "Content-Type":"application/json",
      },
      body:JSON.stringify({
        "user_cache":new URLSearchParams(window.location.search).get("cached"),
        "current_folderID":new URLSearchParams(window.location.search).get("folder"),
        "name":input,
        "tags":[]
      })
    })
    const output = await response.json()
    displayglobalmessage(output["message"])
    if(output["status"]!=200){
      return
    }
    settogglecancelbutton(false)
    await fetchfoldercontent(new URLSearchParams(window.location.search).get("folder"),curPage.current)
  }
  async function removecontentmodule(){ // multiple files or folders
    const handshake = await server_handshake()
    if (handshake["state"]=="invalid"){
      setfatalerrormessage(handshake["message"])
      return
    }
    settogglecancelbutton(false)
    const updatedlist = []
    for(const [key, value] of Object.entries(userSelectedItems.current)){
        updatedlist.push({
          "type":value["type"],
          "itemid":value["id"]
        })
    }
    if (updatedlist.length===0){
      setMISCDIV(null)
      displayglobalmessage("no content selected")
      return
    }
    const response = await fetch(server_URL()+"deletecontent",{
      method:"POST",
      headers:{
        "Content-Type":"application/json",
      },
      body:JSON.stringify({
        "user_cache":new URLSearchParams(window.location.search).get("cached"),
        "contents":updatedlist,
      })
    })
    const output = await response.json()
    
    displayglobalmessage(output["message"])
    await fetchfoldercontent(new URLSearchParams(window.location.search).get("folder"),curPage.current)
  }
  async function movecontentsmodule() { // multiple files or folders
    const handshake = await server_handshake()
    if (handshake["state"]=="invalid"){
      setfatalerrormessage(handshake["message"])
      return
    }
    // chekc if folder exists
    const folderpath = userinput_ref.current.value // new folder path
    if(folderpath===""||folderpath===null){
      return
    }
    settogglecancelbutton(false)
    const updatedlist = []
    for(const [key, value] of Object.entries(userSelectedItems.current)){
        updatedlist.push({
          "type":value["type"],
          "itemid":value["id"]
        })
    }
    if (updatedlist.length===0){
      setMISCDIV(null)
      displayglobalmessage("no content selected")
      return
    }
    const response = await fetch(server_URL()+"movecontent",{
      method:"POST",
      headers:{
        "Content-Type":"application/json",
      },
      body:JSON.stringify({
        "user_cache":new URLSearchParams(window.location.search).get("cached"),
        "folderid":folderpath,
        "contents":updatedlist,
      })
    })
    const output = await response.json()
    
    displayglobalmessage(output["message"])
    await fetchfoldercontent(new URLSearchParams(window.location.search).get("folder"),curPage.current)
  }
  async function findfoldersmodule() { // find folders by name
    const handshake = await server_handshake()
    if (handshake["state"]=="invalid"){
      setfatalerrormessage(handshake["message"])
      return
    }
    const response = await fetch(server_URL()+"findfolders",{
      method:"POST",
      headers:{
        "Content-Type":"application/json",
      },
      body:JSON.stringify({
        "user_cache":new URLSearchParams(window.location.search).get("cached"),
        "foldername":userinput_ref.current.value,
      })
    })
    const output = await response.json()
    if (output["status"]!=200){
      displayglobalmessage(output["message"])
      return
    }

    userinput_ref.current.blur()
    // fill up with folders
    const allfolders = output["content"]

    const arr = []
    if (output["total"]==0){
      arr.push(<span style={{width:"100%",height:"15px",marginTop:"3px",textAlign:"center",fontFamily:"Roboto",fontSize:"12px",userSelect:"none"}}>no content found</span>)
    }
    for(const content of allfolders){
      arr.push(<span style={{width:"100%",height:"15px",marginTop:"3px",fontFamily:"Roboto",fontSize:"12px",cursor:"pointer"}} onClick={()=>{
        cancelmodule()
        curPage.current = 1
        const url = new URL(window.location.href);
        url.searchParams.set("folder", content["id"]);
        window.location.href = url
      }}>{content["name"]}</span>)
    }
    setMISCDIV(
        <div key="updated_miscdiv" style={{position:"absolute",left:"0px",top:"0px",right:"0px",bottom:"0px",zIndex:"1010",background:"rgba(0.5,0.5,0.5,0.2)"}}>
          <div style={{display:"flex",flexDirection:"column",padding:"10px",border:"2px solid black",background:"white",height:"fit-content",width:"fit-content",position:"relative",left:"50%",top:"50%",transform:"translate(-50%,-50%)",borderRadius:"15px"}}>
            <input ref={userinput_ref} placeholder="folder name" style={{width:"200px",height:"15px",border:"2px solid black"}} onKeyDown={(e)=>{enter_function(e.key,3)}}></input>
            <div style={{width:"100%",height:"fit-content",maxHeight:"400px",overflowX:"hidden",overflowY:"auto",display:"flex",flexDirection:"column"}}>{arr}</div>
          </div>
        </div>
    )
  }
  async function cancelmodule(){
    settogglecancelbutton(false)
    setMISCDIV(null)
  }


  function displayglobalmessage(message){
    setglobalmessage(message)
    setTimeout(()=>{
      setglobalmessage(null)
    },800)
  }
  function flashfolderpagefunction(cur,max){
    setflashfolderpagediv(<div style={{width:"100%",height:"100%",display:"flex",alignItems:"center",justifyContent:"center",fontWeight:"bold",fontFamily: "'Inter', sans-serif",fontSize:"14px"}}>
      {cur} / {max}
    </div>)
    setTimeout(()=>{
      setflashfolderpagediv(null)
    },500)
  }


  async function fetchfoldercontent(folder,getpage){
    // clear user selected Items here
    for (const [key,value] of Object.entries(userSelectedItems.current)){
      const div = document.getElementById(value["id"])
      if(div !== null){
        div.style.background = ""
      }
    }
    userSelectedItems.current = {}

    setsortingdisplaydiv(null)
    setpagechangestate(false)
    setMISCDIV(null)
    curPage.current = getpage

    const response = await fetch(server_URL()+"fetchfolder",{
      "method":"POST",
      "headers":{
        "Content-Type":"application/json"
      },
      "body":JSON.stringify({
        "user_cache":new URLSearchParams(window.location.search).get("cached"),
        "folderID":folder,
        "itemperpage":itemperpage.current,
        "setpage":getpage,
        "sorting":[sortingTypes[parseInt(getSS("sortingtype"))],sortingTypes2[parseInt(getSS("sortingtype2"))]]
      })
    })
    const output = await response.json()
    if(output["status"]!=200){
      displayglobalmessage(output["message"])
      setpagenav(null)
      return
    }

    //set currentpath display
    setcurrentfolderpath(output["filepath"])

    // setfiledisplay
    // setfetchedfiledata(output["filedata"])
    fetchedfiledata.current = output["filedata"]

    const soretedDictArr = []
    const dict_temp = output["sortedDict"]
    for (const sortedDict of output["sortedDictOrder"]){
      soretedDictArr.push({
        "tagname":sortedDict,
        "itemsArr":dict_temp[sortedDict]
      })
    }
    soretedDictData.current = soretedDictArr

    formatdisplaydiv()
    whileScrolling()

    //flash current page
    flashfolderpagefunction(output["cur"],output["max"])
 
    // setpage
    setpagenav(
      <div id="pagenav" style={{width:"100%",height:"100%",display:"flex",justifyContent:"center",alignItems:"center",flexDirection:"row"}}>
        <div id="backfull" className={output["cur"]==1?"pagenavcompcss pagenavcompdisabledcss":"pagenavcompcss"} value={1} onClick={()=>{fetchfoldercontent(new URLSearchParams(window.location.search).get("folder"),1)}}>{"<<"}</div>
        <div id="back1" className={output["cur"]==1?"pagenavcompcss pagenavcompdisabledcss":"pagenavcompcss"} value={(output["cur"]-1)+""} onClick={(e)=>{fetchfoldercontent(new URLSearchParams(window.location.search).get("folder"),parseInt(e.currentTarget.getAttribute("value")))}}>{"<"}</div>
        <div className="pagenavcompcss" onClick={()=>{
              setpagechangestate(state => !state)
          }
        }>{output["cur"]}</div>
        <div id="next1" className={output["max"]==0||output["cur"]==output["max"]?"pagenavcompcss pagenavcompdisabledcss":"pagenavcompcss"} value={(output["cur"]+1)+""}  onClick={(e)=>{fetchfoldercontent(new URLSearchParams(window.location.search).get("folder"),parseInt(e.currentTarget.getAttribute("value")))}}>{">"}</div>
        <div id="nextfull" className={output["max"]==0||output["cur"]==output["max"]?"pagenavcompcss pagenavcompdisabledcss":"pagenavcompcss"} value={output["max"]+""} onClick={(e)=>{fetchfoldercontent(new URLSearchParams(window.location.search).get("folder"),parseInt(e.currentTarget.getAttribute("value")))}}>{">>"}</div>
      </div>
    )
  }

  const thumbnailHeight = 200
  const thumbnailMargin = 2
  const sortinglabelHeight = 25
  const sortinglabelMargin = 2

  function formatdisplaydiv(){ // set the format for the scroller to work
    const baseThumbnailWidth = 135
    const parentWidth = ScrollParentDiv.current.offsetWidth
    const IPR = parentWidth/(baseThumbnailWidth+thumbnailMargin*2) //itemsperrow
    const additionalWidth =  ((IPR - Math.trunc(IPR))*baseThumbnailWidth)/Math.trunc(IPR)
    thumbnailwidth.current = baseThumbnailWidth+additionalWidth
    if(fetchedfiledata.current==null||fetchedfiledata.current.length==0){
      return
    }
    //Math.ceil(fetchedfiledata.current.length/Math.floor(parentWidth/thumbnailwidth.current))*(thumbnailHeight+thumbnailMargin*2)
    itemsperrow.current = Math.floor(parentWidth/thumbnailwidth.current)
    let totalHeight = 0
    for (const sortedJSON of soretedDictData.current){
      sortedJSON["segmentRows"] = Math.ceil(sortedJSON["itemsArr"].length/itemsperrow.current)
      totalHeight+=(sortinglabelHeight+sortinglabelMargin*2)+sortedJSON["segmentRows"]*(thumbnailHeight+thumbnailMargin*2)
      sortedJSON["segmentLimit"] = totalHeight
    }
    contentDiv.current.style.height = totalHeight+sortinglabelMargin+"px"
  }
  function getTextWidth(text) {
    // Create a canvas element
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");
    context.font = "500 15px Inter, sans-serif";
    const metrics = context.measureText(text);
    return metrics.width; // width in pixels
  }
  function whileScrolling(){
    const currentScrolled = ScrollParentDiv.current.scrollTop
    setDraggedDisplayDiv(null)
    setDraggedDisplayValues(null)

    let XINDEX = 0
    let YINDEX = 0
    let labelsAdded = 0

    const query_cached = new URLSearchParams(window.location.search).get("cached")
    const fileArr = []
    for(const itemDataJson of soretedDictData.current){
      const max = itemDataJson["segmentLimit"]
      const row = itemDataJson["segmentRows"]

      if(currentScrolled>max){
        YINDEX+=row
        labelsAdded+=1
        continue
      }
      fileArr.push(
        <div key={"sortinglabel_"+itemDataJson["tagname"]} style={{position:"absolute",height:sortinglabelHeight,fontFamily:"Roboto",fontSize:"15px",fontWeight:"bold",display:"flex",alignItems:"center",borderRadius:"10px",background:"rgba(48, 56, 56, 0.25)",left:sortinglabelMargin,right:sortinglabelMargin,top:sortinglabelMargin+YINDEX*(thumbnailHeight+thumbnailMargin*2)+(labelsAdded*(sortinglabelHeight+sortinglabelMargin*2))}}>
          <div style={{width:"10px"}}/>
          {itemDataJson["tagname"]}
        </div>
      )
      labelsAdded+=1

      for(const index of itemDataJson["itemsArr"]){
        if(XINDEX>=itemsperrow.current){
          XINDEX=0
        }
        const topvalue = sortinglabelMargin+YINDEX*(thumbnailHeight+thumbnailMargin*2)+(labelsAdded*(sortinglabelHeight+sortinglabelMargin*2))
        if(topvalue+thumbnailHeight+thumbnailMargin*2<currentScrolled){
          XINDEX+=1
          if(XINDEX>=itemsperrow.current){
            XINDEX=0
            YINDEX+=1
          }
          continue
        }
        const content = fetchedfiledata.current[index-(itemperpage.current*(curPage.current-1))]
        if(content==null){
          return
        }
        let thumbnailname = content["thumbnailid"]
        let fileproperty = content["property"].split("/")[1]

        let contentdisplay = "center"
        let extramargin = 0
        const filedisplaytext = content["name"]+(content["type"]=="folder"?"":"."+fileproperty)
        if(getTextWidth(filedisplaytext)>=thumbnailwidth.current){
          contentdisplay = "left"
          extramargin = 2
        }

        const leftvalue = thumbnailMargin+XINDEX*(thumbnailwidth.current+thumbnailMargin)
        
        if(topvalue>currentScrolled+ScrollParentDiv.current.clientHeight){
          break
        }
        fileArr.push(
          <div key={content["id"]} style={{left:leftvalue,top:topvalue,cursor:"default",width:thumbnailwidth.current+"px",height:thumbnailHeight+"px",display:"flex",flexDirection:"column",position:"absolute",background:content["id"] in userSelectedItems.current?"rgba(118, 252, 252, 0.25)":""}} type = {content["type"]} id = {content["id"]} file_index={content["file_index"]} file_name={content["name"]} 
          onClick={(e)=>{
            const divJson = {
              "id":e.currentTarget.getAttribute("id"),
              "type":e.currentTarget.getAttribute("type"),
              "file_index":e.currentTarget.getAttribute("file_index")
            }

            if (divJson["id"] in userSelectedItems.current){ // activate selected
              const query = new URLSearchParams(window.location.search)
              if(divJson["type"]==="folder"){
                curPage.current = 1
                const url = new URL(window.location.href);
                url.searchParams.set("folder", divJson["id"]);
                window.location.href = url
              }
              else{
                window.location.href = client_url()+"viewer?cached="+query_cached+"&folder="+query.get("folder")+"&index="+divJson["file_index"]
              }
              return
            }
            if(document.getElementById("multiselectmode").textContent=="false"){ // check multiselect
              for (const [key, value] of Object.entries(userSelectedItems.current)) {
                const div = document.getElementById(value["id"])
                if(div !== null){
                  div.style.background = ""
                }
              }
              userSelectedItems.current = {}
            }

            e.currentTarget.style.background = "rgba(118, 252, 252, 0.25)"
            userSelectedItems.current[divJson["id"]] = divJson
          }}>
            <div className="largethumbnailcss">
              <img style={{position:"absolute",bottom:"0px",maxWidth:"90%",maxHeight:"75%",objectFit:"contain",display:content["type"]!="folder"?"none":"block"}} draggable={false} src={server_URL()+"fetchthumbnail/gallery-assests/Folderback.png"}></img>
              <img style={{maxWidth:"70%",maxHeight:"80%",objectFit:"contain",display:content["thumbnailid"]==""?"none":"block",zIndex:"10"}} draggable={false} src={server_URL()+"fetchthumbnail/"+query_cached+"/"+thumbnailname}></img>
              <img style={{position:"absolute",bottom:"0px",maxWidth:"90%",maxHeight:"75%",objectFit:"contain",display:content["type"]!="folder"?"none":"block",zIndex:"11"}} draggable={false} src={server_URL()+"fetchthumbnail/gallery-assests/Folderfront.png"}></img>
            </div>
            <div className="largefilenameviewcss" style={{textAlign:contentdisplay,marginLeft:extramargin}}>{filedisplaytext}</div>
          </div>
        )
        XINDEX+=1
        if(XINDEX>=itemsperrow.current){
          YINDEX+=1
        }
      }
      if(XINDEX<itemsperrow.current){
        YINDEX+=1
      }
      XINDEX = 0
      if(ScrollParentDiv.current.clientHeight+currentScrolled+thumbnailHeight+thumbnailMargin*2<max){
        break
      }
    }

    setVisibleFiledata(fileArr)
  }

  async function setplayerstorage(){
    // check if cache is null
    const query = new URLSearchParams(window.location.search)
    if (query.get("cached")==null||query.get("cached")==""){
      setfatalerrormessage("cache invalid or expired, please login again")
      return
    }
      
    const handshake = await server_handshake()
    if (handshake["state"]=="invalid"){
      setfatalerrormessage(handshake["message"])
      return
    }

    const response = await fetch(server_URL()+"getinitialisationcontent/"+query.get("cached"))
    const output = await response.json()
    if(output["status"]!=200){
        setfatalerrormessage(output["message"])
        return
    }
    
    if(query.get("folder")==null||query.get("folder")==""){
      const url = new URL(window.location.href)
      url.searchParams.set("folder",output["main_dir"])
      window.history.pushState({},'',url)
    }

    itemperpage.current = output["itemperpage"]

    let availspace = output["available-space"]
    if(availspace<1){
      availspace = 1
    }
    let toDisplay = output["space-used"]/availspace
    let symbol = "GB"
    const TB_check = toDisplay/1000

    if(TB_check > 1){
      toDisplay = TB_check
      symbol = "TB"
    }

    setavailablestoragedisplay(
      <div>
        <span style={{display:'flex',height:"80%",width:"100%",fontWeight:"bold",justifyContent:"center",alignItems:"center",fontSize:"15px",whiteSpace:"nowrap"}}>
          {toDisplay.toFixed(2)} {symbol}
        </span>
        <div style={{display:'flex',width:"95%",height:"18%",background:"lightgray",border:"1px solid black",borderRadius:"5px"}}>
          <div style={{width:output["percentage"]+"%",background:output["percentage"]>80?"red":"green",height:"100%",borderRadius:"5px"}}></div>
        </div>
      </div>
    )

    setsorting(getSS("sortingtype"))
    setsorting2(getSS("sortingtype2"))

    fetchfoldercontent(new URLSearchParams(window.location.search).get("folder"),curPage.current)
  }
  useEffect(()=>{
    if(getSS("sortingtype")==null){
      setSS("sortingtype",sorting)
    }
    if(getSS("sortingtype2")==null){
      setSS("sortingtype2",sorting2)
    }
    if(getSS("hidesystemtray")!=null){
      sethidesystemtray(true?getSS("hidesystemtray") === "true":false)
    }

    setplayerstorage()
    if (ScrollParentDiv.current!==null){
      ScrollParentDiv.current.addEventListener("scroll",()=>{whileScrolling()})
    }

    const handleKeyUp = (event) => {
        if (event.key === "Escape") {
            for (const [key, value] of Object.entries(userSelectedItems.current)) {
                const div = document.getElementById(value["id"])
                if(div !== null){
                  div.style.background = ""
                }
              }
            userSelectedItems.current = {};
        }
    };
    window.addEventListener("keyup", handleKeyUp);
    return () => {
        window.removeEventListener("keyup", handleKeyUp);
    };

  },[])
  useEffect(()=>{
    if(pagechangestate){
      setpagechangediv(
        <input id="changepageid" placeholder="page?" autoFocus className="pagenumberinputcss" input="number" onKeyDown={(e)=>{
          if(e.key!="Enter"){
            return
          }
          const div = document.getElementById("changepageid")
          var value = parseInt(div.value)
          if(value==null||isNaN(value)||value<1){
            value = 1
          }
          div.value = ""
          fetchfoldercontent(new URLSearchParams(window.location.search).get("folder"),value)
        }}></input>
      )
    }
    else{
      setpagechangediv(null)
    }
  },[pagechangestate])
  useEffect(()=>{
    if(togglecancelbutton){
      if(userinput_ref.current!=null){
        userinput_ref.current.focus()
      }
      setcancelbutton(
        <button style={{position:"absolute",right:"20px",top:"20px",width:"30px",height:"30px",background:"white",borderRadius:"10px",display:"flex",cursor:"pointer",zIndex:'1011'}} onClick={cancelmodule}>
          <img src={server_URL()+"fetchthumbnail/gallery-assests/Cancel.png"} style={{width:"100%",height:"100%",}}></img>
        </button>
      )
    }
    else{
      setcancelbutton(null)
    }
  },[togglecancelbutton])
  return (
      <div style={{position:"absolute",left:"0px",bottom:"0px",right:"0px",top:"0px",background:"burlywood"}}>
        <div style={{display:fatalerrormessage!=null?"flex":"none",position:"absolute",left:"50%",top:"50%",transform:"translate(-50%,-50%)",flexDirection:"column"}}>
          <span style={{fontSize:"20px",marginBottom:"10px",color:"red",textAlign:"center"}}>{fatalerrormessage}</span>
          <a href={client_url()} style={{width:"100%",textAlign:"center"}} onClick={()=>{
            setSS("main_cached","")
          }}>home</a>
        </div>
        <div id="main_display" style={{width:"100%",height:"100%",overflow:"hidden",padding:"0px",display:fatalerrormessage==null?"flex":"none"}} onDragOver={handledragover} onDragLeave={handledragleave} onDrop={handleDrop} >
          <div id="removemode" style={{display:"none"}}>false</div>
          <div id="multiselectmode" style={{display:"none"}}>false</div>
          <div style={{display:dragdrop?"flex":"none",zIndex:"1000", pointerEvents:"none"}} className="draganddropdisplaycss">Drop Files</div>
          <div style={{display:filedisplayarr.length!=0?"flex":"none",zIndex:"1000",background:"white"}} className="displayfilenamecontainerscss">
            <div style={{width:"100%",textAlign:"center"}}>Files Uploading</div>
            <div className="progressbarcss" style={{display:progress==null?"none":"block"}}>{progress}</div>
            {filedisplayarr}
          </div>
          <div style={{width:"100%",height:"100%",border:"1px solid black",display:"flex",overflowY: "auto"}} onTouchStart={handlePointerDown} onTouchEnd={handlePointerUp} onTouchMove={handleTouchMove} onPointerDown={handlePointerDown} onPointerUp={handlePointerUp}> 
            <div id="navbarcontent" style={{minWidth:"35px",width:"35px",height:"100%",background:"burlywood",borderRight:"2px solid black",flexDirection:"column",alignItems:"center",display:hidesystemtray?"none":"flex"}}>
                    <div className="navbarcomponentcss" id="uploadFiles" onMouseEnter={(e)=>{
                      const bound = e.currentTarget.getBoundingClientRect()
                      settooltip(
                        <div style={{position:"absolute",zIndex:"1007",top:bound.bottom+5,left:bound.left+(bound.width/2),background:"white",padding:"2px",border:"1px solid black",borderRadius:"5px"}}>upload files</div>
                      )
                    }} onMouseLeave={()=>{settooltip(null)}} onClick={(e)=>{
                      if(fatalerrormessage!=null){
                        return
                      }
                      setMISCDIV(
                          <div style={{position:"absolute",left:"0px",top:"0px",right:"0px",bottom:"0px",zIndex:"1010",background:"rgba(0.5,0.5,0.5,0.2)"}}>
                            <div style={{display:"flex",flexDirection:"column",padding:"10px",border:"2px solid black",background:"white",height:"fit-content",width:"fit-content",position:"relative",left:"50%",top:"50%",transform:"translate(-50%,-50%)",borderRadius:"15px"}}>
                              <FileUploader handleChange={(files)=>{fileDetectedfunction(files)}} name="file" multiple={true}/>
                            </div>
                          </div>
                      )
                      settogglecancelbutton(true)
                    }}>
                      <img style={{maxWidth:"90%",maxHeight:"90%",objectFit:"contain"}} draggable={false} src={server_URL()+"fetchthumbnail/gallery-assests/Upload.png"}></img>
                    </div>

                    {/* <div className="navbarcomponentcss" id="multiselecttoggle" onMouseEnter={(e)=>{
                      const bound = e.currentTarget.getBoundingClientRect()
                      settooltip(
                        <div style={{position:"absolute",zIndex:"1007",top:bound.bottom+5,left:bound.left+(bound.width/2),background:"white",padding:"2px",border:"1px solid black",borderRadius:"5px"}}>multi select mode</div>
                      )
                    }} onMouseLeave={()=>{settooltip(null)}} onClick={(e)=>{
                      if(fatalerrormessage!=null){
                        return
                      }
                      const multiselectdiv = document.getElementById("multiselectmode")
                      if(multiselectdiv.textContent == "false"){
                        multiselectdiv.textContent = "true"
                        e.currentTarget.style.border = "2px dotted black"
                        e.currentTarget.style.background = "rgba(1, 1, 1, 0.288)"
                      }
                      else{
                        multiselectdiv.textContent = "false"
                        e.currentTarget.style.border = "none"
                        e.currentTarget.style.background = ""
                      }
                    }}>
                      <img style={{maxWidth:"90%",maxHeight:"90%",objectFit:"contain"}} draggable={false} src={server_URL()+"fetchthumbnail/gallery-assests/Multiselect.png"}></img>
                    </div> */}

                    <div className="navbarcomponentcss" id="createfolder" onMouseEnter={(e)=>{
                        const bound = e.currentTarget.getBoundingClientRect()
                        settooltip(
                          <div style={{position:"absolute",zIndex:"1007",top:bound.bottom+5,left:bound.left+(bound.width/2),background:"white",padding:"2px",border:"1px solid black",borderRadius:"5px"}}>create folder</div>
                        )
                      }} onMouseLeave={()=>{settooltip(null)}} onClick={(e)=>{
                        if(fatalerrormessage!=null){
                          return
                        }
                        setMISCDIV(
                          <div style={{position:"absolute",left:"0px",top:"0px",right:"0px",bottom:"0px",zIndex:"1010",background:"rgba(0.5,0.5,0.5,0.2)"}}>
                            <div style={{display:"flex",flexDirection:"column",padding:"10px",border:"2px solid black",background:"white",height:"fit-content",width:"fit-content",position:"relative",left:"50%",top:"50%",transform:"translate(-50%,-50%)",borderRadius:"15px"}}>
                              <span style={{width:"100%",textAlign:"center",userSelect:"none",cursor:"default",fontFamily:"Roboto",fontWeight:"bold",fontSize:"14px"}}>Create Folder</span>
                              <input ref={userinput_ref} placeholder="folder name" style={{width:"200px",margin:"2px",height:"15px"}} onKeyDown={(e)=>{enter_function(e.key,0)}}></input>
                            </div>
                          </div>
                        )
                        settogglecancelbutton(true)
                      }}>
                        <img style={{maxWidth:"90%",maxHeight:"90%",objectFit:"contain"}} draggable={false} src={server_URL()+"fetchthumbnail/gallery-assests/Folderplus.png"}></img>
                    </div>

                    <div className="navbarcomponentcss" id="removefiles" onMouseEnter={(e)=>{
                      const bound = e.currentTarget.getBoundingClientRect()
                      settooltip(
                        <div style={{position:"absolute",zIndex:"1007",top:bound.bottom+5,left:bound.left+(bound.width/2),background:"white",padding:"2px",border:"1px solid black",borderRadius:"5px"}}>remove files</div>
                      )
                    }} onMouseLeave={()=>{settooltip(null)}} onClick={(e)=>{
                      if(fatalerrormessage!=null){
                        return
                      }
                      if(Object.keys(userSelectedItems.current).length == 0){
                        return
                      }
                      setMISCDIV(
                        <div style={{position:"absolute",left:"0px",top:"0px",right:"0px",bottom:"0px",zIndex:"1010",background:"rgba(0.5,0.5,0.5,0.2)"}}>
                          <div style={{display:"flex",flexDirection:"column",padding:"10px",border:"2px solid black",background:"white",height:"fit-content",width:"fit-content",position:"relative",left:"50%",top:"50%",transform:"translate(-50%,-50%)",borderRadius:"15px"}}>
                            <span style={{fontFamily:"Roboto",fontSize:"14px",fontWeight:"bold"}}>Are you sure you want to delete?</span>
                            <div style={{display:"flex",justifyContent:"center"}}> 
                              <button style={{width:"50px",margin:"5px"}} onClick={()=>{enter_function("Enter",1)}}>yes</button>
                              <button style={{width:"50px",margin:"5px"}} onClick={()=>{cancelmodule()}}>no</button>
                            </div>
                          </div>
                        </div>
                      )
                      settogglecancelbutton(true)
                    }}>
                      <img style={{maxWidth:"90%",maxHeight:"90%",objectFit:"contain"}} draggable={false} src={server_URL()+"fetchthumbnail/gallery-assests/Trashcan.png"}></img>
                    </div>

                    <div className="navbarcomponentcss" id="movefiles" onMouseEnter={(e)=>{
                      const bound = e.currentTarget.getBoundingClientRect()
                      settooltip(
                        <div style={{position:"absolute",zIndex:"1007",top:bound.bottom+5,left:bound.left+(bound.width/2),background:"white",padding:"2px",border:"1px solid black",borderRadius:"5px"}}>move files</div>
                      )
                    }} onMouseLeave={()=>{settooltip(null)}} onClick={(e)=>{
                      if(fatalerrormessage!=null){
                        return
                      }
                      if(Object.keys(userSelectedItems.current).length == 0){
                        return
                      }
                      setMISCDIV(
                          <div style={{position:"absolute",left:"0px",top:"0px",right:"0px",bottom:"0px",zIndex:"1010",background:"rgba(0.5,0.5,0.5,0.2)"}}>
                            <div style={{display:"flex",flexDirection:"column",padding:"10px",border:"2px solid black",background:"white",height:"fit-content",width:"fit-content",position:"relative",left:"50%",top:"50%",transform:"translate(-50%,-50%)",borderRadius:"15px"}}>
                              <span style={{fontFamily:"Roboto",fontSize:"14px",fontWeight:"bold",width:"100%",textAlign:"center",userSelect:"none",cursor:"default"}}>Move Content</span>
                              <input ref={userinput_ref} placeholder="file ID" style={{width:"200px",height:"15px"}} onKeyDown={(e)=>{enter_function(e.key,2)}}></input>
                            </div>
                          </div>
                      )
                      settogglecancelbutton(true)
                    }}>
                      <img style={{maxWidth:"90%",maxHeight:"90%",objectFit:"contain"}} draggable={false} src={server_URL()+"fetchthumbnail/gallery-assests/Moveicon.png"}></img>
                    </div>

                    <div className="navbarcomponentcss" id="findfolder" onMouseEnter={(e)=>{
                      const bound = e.currentTarget.getBoundingClientRect()
                      settooltip(
                        <div style={{position:"absolute",zIndex:"1007",top:bound.bottom+5,left:bound.left+(bound.width/2),background:"white",padding:"2px",border:"1px solid black",borderRadius:"5px"}}>find folders</div>
                      )
                    }} onMouseLeave={()=>{settooltip(null)}} onClick={(e)=>{
                      if(fatalerrormessage!=null){
                        return
                      }
                      setMISCDIV(
                          <div style={{position:"absolute",left:"0px",top:"0px",right:"0px",bottom:"0px",zIndex:"1010",background:"rgba(0.5,0.5,0.5,0.2)"}}>
                            <div style={{display:"flex",flexDirection:"column",padding:"10px",border:"2px solid black",background:"white",height:"fit-content",maxHeight:"400px",width:"fit-content",position:"relative",left:"50%",top:"50%",transform:"translate(-50%,-50%)",borderRadius:"15px"}}>
                              <input ref={userinput_ref} placeholder="folder name" style={{width:"200px",height:"15px",border:"1px solid black"}} onKeyDown={(e)=>{enter_function(e.key,3)}}></input>
                            </div>
                          </div>
                      )
                      settogglecancelbutton(true)
                    }}>
                      <img style={{maxWidth:"90%",maxHeight:"90%",objectFit:"contain"}} draggable={false} src={server_URL()+"fetchthumbnail/gallery-assests/Findfolder.png"}></img>
                    </div>
            </div>
            <div id="rightcontent1" style={{width:"100%",height:"100%",display:"flex",flexDirection:"column",overflow:"hidden",userSelect:"none"}}>
                <div id="currentfilepath" className="currentfilepathcss" onClick={async (e)=>{
                  if(fatalerrormessage!=null){
                    return
                  }
                  await navigator.clipboard.writeText(new URLSearchParams(window.location.search).get("folder"));
                  displayglobalmessage("copied file path")
                }}>
                  <div style={{width:"5px"}}></div>
                  <div id="filepathdisplay" style={{whiteSpace:"nowrap",textOverflow:"ellipsis",textWrap:"nowrap"}}>{currentfolderpath}</div>
                </div>
                <div style={{display:pagenav==null?"none":"block",width:"100%",height:"35px",minHeight:"35px",background:"wheat",borderBottom:"1px solid black",display:"flex",alignItems:"center"}}>
                  {/* <div id="togglepanelbutton" style={{width:"20px",height:"20px",margin:"5px",display:"flex",justifyContent:"center",alignItems:"center",borderRadius:"5px"}} onClick={(e)=>{
                    settogglepanels(prev=>{
                      let value = prev
                      if(value+1>=maxPanels){
                        return 0
                      }
                      else{
                        return prev+1
                      }
                    })

                    document.getElementById("togglepanelbutton").style.background = "rgba(0.7,0.7,0.7,0.5)"
                    setTimeout(()=>{
                      document.getElementById("togglepanelbutton").style.background = ""
                    },50)
                  }}>
                    <img style={{width:"80%",height:"80%",objectFit:"contain"}} src={server_URL()+"fetchthumbnail/gallery-assests/Changepanel.png"}></img>
                  </div> */}
                  <div id="toggle0_contents" style={{width:"100%",height:"100%",position:"relative",display:togglepanels==0?"flex":"none",alignItems:"center"}}>
                    {pagenav}
                    {pagechangediv}
                  </div>
                  <div id="toggle1_contents" style={{width:"100%",height:"100%",position:"relative",display:togglepanels==1?"flex":"none",alignItems:"center"}}>
                    {/* <div style={{width:"50px",height:"20px",border:"1px solid black",display:"flex",margin:"5px",position:"relative"}}>
                      <img id="settosmall" style={{width:"50%",height:"100%",objectFit:"contain"}} src={server_URL()+"fetchthumbnail/gallery-assests/Smalllist.png"}></img> 
                      <img id="settolarge" style={{width:"50%",height:"100%",objectFit:"contain"}} src={server_URL()+"fetchthumbnail/gallery-assests/Largelist.png"}></img>
                      <div style={{width:"50%",position:"absolute",background:"rgba(0.7,0.7,0.7,0.7)",height:"100%",cursor:"pointer",transform:viewtype=="large"?"translateX(0%)" : "translateX(100%)",transition:"transform 0.3s ease-in-out"}} onClick={(e)=>
                        setviewtype(prevItems=>{
                          userSelectedItems.current = {}
                          prevItems=="small"?prevItems="large":prevItems="small"
                          setSS("viewtype",prevItems)
                          return(prevItems)
                        })}></div>
                    </div> */}
                    <div id="hidesytemtray" style={{width:"25px",height:"20px"}} onClick={(e)=>{
                      sethidesystemtray(prev =>{
                        const newValue = !prev
                        setSS("hidesystemtray",newValue)
                        return newValue
                      })
                    }}>
                      <img style={{width:"100%",height:"100%",objectFit:"contain",cursor:"pointer"}} src={server_URL()+"fetchthumbnail/gallery-assests/Displaytray.png"}></img>
                    </div>
                    <div id="hidesortingtray" style={{width:"25px",height:"20px",cursor:"pointer"}} onClick={(e)=>{
                      const parentX = e.currentTarget.getBoundingClientRect().left
                      const parentY = e.currentTarget.getBoundingClientRect().top+25
                      setsortingdisplaydiv(prev=>{
                        if(prev!=null){
                          return null
                        }
                        return (<div style={{position:"absolute",width:"fitcontent",height:"fitcontent",left:parentX,top:parentY,background:"white",border:"1px solid black",zIndex:"700",display:"flex",flexDirection:"column"}}>
                          <span style={{fontSize:"10px",borderBottom:"1px solid black",margin:"3px",fontWeight:"bold",userSelect:"none"}}>sort</span>
                            {
                              sortingTypes.map((content,index)=>{
                                return(<span key={"sortingVlaue"+index} style={{fontFamily:"roboto",fontWeight:"bold",fontSize:"12px",cursor:"pointer",userSelect:"none",margin:"3px",width:"80px",height:"14px",background:index==sorting?"lightgrey":""}} onClick={()=>{
                                  setSS("sortingtype",index)
                                  setsorting(index)
                                  fetchfoldercontent(new URLSearchParams(window.location.search).get("folder"),1)
                                }}>
                                  {content}
                                </span>)
                              })
                            }
                          <span style={{fontSize:"10px",borderBottom:"1px solid black",margin:"3px",fontWeight:"bold",userSelect:"none",marginTop:"5px"}}>direction</span>
                            {
                              sortingTypes2.map((content,index)=>{
                                return(<span key={"sortingVlaue2"+index} style={{fontFamily:"roboto",fontWeight:"bold",fontSize:"12px",cursor:"pointer",userSelect:"none",margin:"3px",width:"80px",height:"14px",background:index==sorting2?"lightgrey":""}}onClick={()=>{
                                  setSS("sortingtype2",index)
                                  setsorting2(index)
                                  fetchfoldercontent(new URLSearchParams(window.location.search).get("folder"),1)
                                }}>
                                  {content}
                                </span>)
                              })
                            }

                        </div>)
                      })
                    }}>
                      <img style={{width:"100%",height:"100%",objectFit:"contain"}} src={server_URL()+"fetchthumbnail/gallery-assests/Sort.png"}></img>
                    </div>
                    <div style={{position:"absolute",right:"2px",top:"50%",width:"90px",transform:"translate(0%,-50%)",height:"25px",display:"flex",flexDirection:"column"}}>
                      {flashfolderpagediv!=null?flashfolderpagediv:availablestoragedisplay}
                    </div>
                  </div>
                </div>
                <div ref={ScrollParentDiv} style={{display:"flex",width:"100%",height:"100%",overflowX:"hidden"}} onMouseMove={handlemousemoved} onMouseDown={handlemouseclicked} onMouseUp={handlemousereleased} onMouseLeave={handlemousereleased}>
                  <div ref={contentDiv} style={{position:"relative",width:"100%"}} >
                      {visibleFileData}
                  </div>
                </div>
            </div>
            {/* <div id="rightcontent2" style={{width:"100%",height:"100%",display:rightcontent==1?"flex":"none",flexDirection:"column",overflow:"hidden",userSelect:"none"}}>
              <input ref={userinput_ref} style={{maxWidth:"100%",height:"15px",margin:"5px"}} placeholder="folder name" onKeyDown={(e)=>{e.key,3}}></input>
            </div> */}
          </div>
          <div id="globalmessage" style={{position:"absolute",left:"5px",right:"5px",top:"20%",fontSize:"20px",zIndex:"1200",textAlign:"center",background:"white",borderRadius:"10px",fontWeight:"bold",fontFamily: "'Inter', sans-serif"}}>{globalmessage}</div>
          {navbartooltip}
          {misc_components}
          {cancelbutton}
          {sortingdisplaydiv}
          {draggedDisplayDiv}
        </div>
      </div>
  );
}

export default App;
